import { Injectable } from '@angular/core';
import {  Actions, createEffect, ofType } from '@ngrx/effects';
import { SnackbarService } from '@shared';
import { UserService } from '../services';
import {
  getProfile,
  getProfileFailure,
  getProfileSuccess,
  getUser,
  getUserFailure,
  getUserSuccess,
  updateProfile,
  updateProfileFailure,
  updateProfileSuccess,
} from './user.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { IUser } from '../interfaces';
import { ProfileService } from '@app/private-office/modules/profile/services';
import { IProfile } from '@app/private-office/modules/profile/interfaces';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorsService } from '@app/errors/errors.service';

@Injectable()
export class UserEffects {
  constructor(
    private _actions$: Actions<any>,
    private _userService: UserService,
    private _profileService: ProfileService,
    private _snackbarService: SnackbarService,
    private _errorsService: ErrorsService,
    private _router: Router,
  ) {}

  getUser$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getUser),
      mergeMap(() =>
        this._userService.getUser().pipe(
          map((user: IUser) => getUserSuccess({ user })),
          catchError((err: HttpErrorResponse) => {
            console.log('user error', err);
            // if (err.error.detail) {
            //   this._errorsService.openPopup(err)
            // } else {
            this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            // }
            return of(getUserFailure());
          }),
        ),
      ),
    ),
  );

  getProfile$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getProfile),
      mergeMap(() =>
        this._profileService.getProfile().pipe(
          map((profile: IProfile) => getProfileSuccess({ profile })),
          catchError(() => {
            this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            return of(getProfileFailure());
          }),
        ),
      ),
    ),
  );

  updateProfile$ = createEffect(() =>
    this._actions$.pipe(
      ofType(updateProfile),
      mergeMap(({ profile: data }) =>
        this._profileService.updateProfile(data).pipe(
          map((res) => {
            return updateProfileSuccess({ profile: res });
          }),
          catchError(() => {
            this._snackbarService.openSnackBar('Что-то пошло не так... Попробуйте еще раз.');
            return of(updateProfileFailure());
          }),
        ),
      ),
    ),
  );
}
